/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Objednávka.
 */
export interface TourRequestOrder { 
    id: number;
    title: string;
    type: string;
    price?: string | null;
    kind?: string | null;
    location?: string | null;
    cooperativeName?: string | null;
    cooperativeIco?: string | null;
    rentalAgreementDate?: string | null;
    ownership: boolean;
    ownershipList?: string | null;
    cadastralArea?: string | null;
    houseShare?: string | null;
    landShare?: string | null;
    sizeInM2?: number | null;
    purchasePrice?: string | null;
    apartmentNumber?: string | null;
    floor?: string | null;
    landParcelNumber?: string | null;
}

